import React, { useEffect } from "react";
import {
  DropdownButton,
  Dropdown,
  Row,
  OverlayTrigger,
  Tooltip,
  Button,
} from "react-bootstrap";
import { connect, useSelector, useDispatch } from "react-redux";
import { getExchanges, selectExchange } from "../../actions/setting-action";
import { SELECT_EXCHANGE } from "../../actions/types";
import { ExchangeStatus, ExchangeStatusName } from "../../Const";
import "./ExchangeSelect.css";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import { signOut } from "../../actions/auth-action";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { loadExchangePairs } from "../../actions/bot-action";

const ExchangeSelect = (props) => {
  const { title, showExchange, getExchanges, selectExchange, signOut,loadExchangePairs,url } = props;
  const {t} = useTranslation()

  var exchanges = useSelector((state) => state.settings.exchanges) || [];
  const exchangeId =
    useSelector((state) => state.settings.selectedExchangeId) || 0;
  const dispatch = useDispatch();
  exchanges = exchanges.filter((item) => item.is_connected || item.id === 0);
  exchanges.sort((el1, el2) => el1.order - el2.order)
  const selectedExchange = useSelector(
    (state) => state.settings.selectedExchange
  );
  const email = useSelector((state) => state.auth.user.email);
  const name = useSelector((state) => state.auth.user.name) || email || "User";
  const upperName = name.toUpperCase();

  useEffect(() => {
    getExchanges();
  }, []);
  useEffect(() => {
    const exchange =
      (exchanges && exchanges.find((item) => item.id === exchangeId)) || {};
      if (Object.keys(exchange).length > 0) {
        dispatch({
          type: SELECT_EXCHANGE,
          payload: exchange,
        });
      }
  }, [exchanges, exchangeId]);

  const exchangeItems =
    exchanges &&
    exchanges.map((item) => {
      return (
        <Dropdown.Item key={item.id} eventKey={item.id}>
          {item.name}
        </Dropdown.Item>
      );
    });
  const changeExchange = (id)=>{
    selectExchange(id);
    loadExchangePairs(id).then((code)=>{
      if(code==200){
        //window.location.reload(false);
      }
    }).catch((err)=>{

    })
    //getExchangePairs(id,true)
    //
  }
  return (
    <div className="exchange-selection">
      <Row noGutters className="justify-content-between align-items-center">
        <span className="header-name"><Link to={url}>{title}</Link></span>
        <div style={{width:"45%"}}><a href="https://cityindex.cfdhero.com" target="_blank"><img src="/images/CityIndex_Bonus.jpg" style={{width:"100%"}}></img></a></div>
        <div className="text-right d-flex align-items-center">
        {showExchange ? (
          <>
          <a className="mr-2 bold" href="https://docs.cfdhero.com/" target="_blank">
            <Button>User Guide</Button></a>
          {/* <a className="mr-2 bold" href="https://docs.tradingboteco.com/faq/frequently-asked-questions" target="_blank"><Button>FAQ</Button></a> */}
         </>
          ): (
            <></>
          )}
          {showExchange ? (
            <div className="d-flex">
              {selectedExchange &&
                (selectedExchange.status !== ExchangeStatus.ok ? (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip>
                        {ExchangeStatusName[selectedExchange.status]}
                      </Tooltip>
                    }
                  >
                    <i className="fas"></i>
                  </OverlayTrigger>
                ) : // <img
                //   src={selectedExchange.image}
                //   style={{ marginRight: 10, marginTop: 4 }}
                //   width={20}
                //   height={20}
                // />
                null)}
              <DropdownButton
                onSelect={(e) => changeExchange(Number(e))}
                title={(selectedExchange && selectedExchange.name) || "Paper"}
                className="dashboard-tour-paper"
              >
                {exchangeItems}
              </DropdownButton>
            </div>
          ) : (
            <></>
          )}

          <Dropdown>
            <DropdownToggle as="div">
              <span className="account">{upperName[0]}</span>
            </DropdownToggle>

            <DropdownMenu>
              <Dropdown.Item>
                <i className="fas fa-user-circle menu-icon" />
                <span className="menu-text">{upperName}</span>
              </Dropdown.Item>
              <Dropdown.Item href="/setting">
                <i className="fas fa-cog menu-icon" />
                <span className="menu-text">{t("settings")}</span>
              </Dropdown.Item>
              <Dropdown.Item href="/help">
                <i className="fas fa-question-circle menu-icon" />
                <span className="menu-text">{t("help-center")}</span>
              </Dropdown.Item>
              <Dropdown.Item href="/affiliate">
                <i className="fas fa-question-circle menu-icon" />
                <span className="menu-text">{t("Affiliate")}</span>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item href="#" onClick={() => signOut()}>
                <i className="fas fa-sign-out-alt menu-icon text-danger" />
                <span className="menu-text">{t("logout")}</span>
              </Dropdown.Item>
            </DropdownMenu>
          </Dropdown>
        </div>
      </Row>
    </div>
  );
};

export default connect(null, { getExchanges, selectExchange, loadExchangePairs,signOut })(
  ExchangeSelect
);
